import { createFileRoute } from "@tanstack/react-router";

import { BrandEditPage } from "@/features/brands/edit";

export const Route = createFileRoute("/_auth/_app-shell/brands/$brandId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { brandId } = Route.useParams();

  return <BrandEditPage brandId={brandId} />;
}
